import React from 'react';
import {
  Text,
  Accordion
} from '@comicrelief/component-library';
import PropTypes from 'prop-types';
import renderRichText from '../RichText/RichText';

import {
  Row,
  MoreInfo
} from './Prize.styles';

const getFaqAndTermsTitle = (faQs, termsConditions) => {
  if (faQs && termsConditions) return 'FAQs & Terms and conditions';
  if (faQs) return 'FAQs';
  if (termsConditions) return 'Terms and conditions';
  return '';
};

const FurtherInfo = ({
  termsRef, entryByPost, termsConditions, faQs
}) => {
  const moreInfoTitle = getFaqAndTermsTitle(faQs, termsConditions);
  return (
    <>
      {moreInfoTitle && (
        <MoreInfo ref={termsRef}>
          <Text tag="h2" size="xl">
            {moreInfoTitle}
          </Text>
        </MoreInfo>
      )}
      {entryByPost
        ? (
          <Row>
            <Accordion
              title="How to enter: Post, Mobile or Online"
            >
              {renderRichText(entryByPost, 'white', 'accordion')}
            </Accordion>
          </Row>
        )
        : null}
      {termsConditions
        ? (
          <Row id="terms-conditions">
            <Accordion
              title="Terms & Conditions"
            >
              {renderRichText(termsConditions, 'white', 'accordion')}
            </Accordion>
          </Row>
        )
        : null}
      {faQs
        ? (
          <Row>
            <Accordion
              title="Frequently Asked Questions"
            >
              {renderRichText(faQs, 'white', 'accordion')}
            </Accordion>
          </Row>
        )
        : null}
    </>
  );
};

FurtherInfo.propTypes = {
  termsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape()
  ]),
  entryByPost: PropTypes.shape(),
  termsConditions: PropTypes.shape(),
  faQs: PropTypes.shape()
};

export default FurtherInfo;
